import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Gallery from './components/Gallery';
import ShareYourWork from './components/ShareYourWork';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check localStorage for saved auth state
    return localStorage.getItem('adminAuth') === 'true';
  });
  const isAdminRoute = window.location.pathname === '/admin';

  const handleAdminLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('adminAuth', 'true');
  };

  const handleAdminLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('adminAuth');
    window.location.href = '/';
  };

  useEffect(() => {
    // Redirect to home if not authenticated and on admin route
    if (isAdminRoute && !isAuthenticated) {
      // Stay on admin route to show login
    }
  }, [isAdminRoute, isAuthenticated]);

  // Show admin section if on /admin route
  if (isAdminRoute) {
    if (!isAuthenticated) {
      return <AdminLogin onLogin={handleAdminLogin} />;
    }
    
    return (
      <div className="App min-h-screen bg-gray-50">
        <div className="bg-blue-600 text-white p-4 flex justify-between items-center">
          <h1 className="text-xl font-bold">Admin Dashboard</h1>
          <button
            onClick={handleAdminLogout}
            className="bg-white text-blue-600 px-4 py-2 rounded hover:bg-gray-100 transition"
          >
            Logout
          </button>
        </div>
        <AdminDashboard />
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-bg-primary">
      <Navbar />
      
      {/* Share Your Work Section - Top on Mobile */}
      <div className="pt-20 md:hidden">
        <ShareYourWork />
      </div>

      {/* Main Content */}
      <main className="pt-0 md:pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-text-primary mb-6">
              My Photography
            </h1>
            <p className="text-xl text-text-secondary max-w-2xl mx-auto mb-12">
              Welcome to my photography portfolio. This is where I share my passion for capturing moments.
            </p>
            
            {/* Photo Gallery */}
            <div className="mt-12">
              <Gallery />
            </div>
          </div>
        </div>
      </main>

      {/* Share Your Work Section - Bottom on Desktop */}
      <div className="hidden md:block">
        <ShareYourWork />
      </div>
      
      <Footer />
      
      {/* Admin Login Access */}
      <div className="fixed bottom-4 right-4">
        <a
          href="/admin"
          className="bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-gray-700 transition text-sm block"
        >
          Admin Login
        </a>
      </div>
    </div>
  );
}

export default App;
